import TtamInteractiveAddOnDesc from './desc/index.vue';
import TtamInteractiveAddOnEditor from './editor/index.vue';
import TtamInteractiveAddOnDrawer from './drawer/index.vue';
import TtamInteractiveAddOnErrorTip from './error-tip/index.vue';
import TtamInteractiveAddOnPreviewThumbnail from './preview/index.vue';
import TtamInteractiveAddOnEditorDrawer from './drawer/interactive-add-on-editor.vue';
import TtamInteractiveAddOnLibraryDrawer from './drawer/interactive-add-on-library.vue';

import * as hooks from './hooks';
export default {
  TtamInteractiveAddOnDesc,
  TtamInteractiveAddOnEditor,
  TtamInteractiveAddOnDrawer,
  TtamInteractiveAddOnErrorTip,
  TtamInteractiveAddOnPreviewThumbnail,
  TtamInteractiveAddOnEditorDrawer,
  TtamInteractiveAddOnLibraryDrawer,
  ...hooks,
};
